import type {
  LC_SendMonthlyCutToPayrollResultOut,
  LC_SendMonthlyCutsToPayrollOut,
  LC_GetPayrollSubmissionAvailabilityOut,
  PayrollSubmissionResult,
  PayrollSubmissionSummary,
  PayrollSubmissionAvailability,
} from '../types';


// Transporte → modelo de dominio del resultado por corte que muestra el diálogo de resultado.
const mapResult = (out: LC_SendMonthlyCutToPayrollResultOut): PayrollSubmissionResult => ({
  monthlyCutId: out.monthlyCutId,
  companyName: out.companyName ?? null,
  outcome: out.outcome,
  detail: out.detail ?? null,
  conceptCount: out.conceptCount ?? null,
});

// Transporte → resumen de dominio (contadores + resultado por corte) del envío a remuneraciones.
export const mapPayrollSubmissionSummary = (
  out: LC_SendMonthlyCutsToPayrollOut,
): PayrollSubmissionSummary => ({
  targetSystem: out.targetSystem,
  results: (out.results ?? []).map(mapResult),
  sentCount: out.sentCount,
  skippedClosedCount: out.skippedClosedCount,
  errorCount: out.errorCount,
  notFoundCount: out.notFoundCount,
  totalProcessed: out.totalProcessed,
});

// Transporte → modelo de dominio de disponibilidad de la integración de remuneraciones.
export const mapPayrollSubmissionAvailability = (
  out: LC_GetPayrollSubmissionAvailabilityOut,
): PayrollSubmissionAvailability => ({
  available: out.available,
  targetSystem: out.targetSystem,
});
